import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOneToOne = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 1.375,
			cy: 1.375,
			r: 1.375,
			transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 5.04199 9.37402)",
			stroke: "currentColor",
			strokeWidth: .916667,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.33325 7.99967L7.99992 7.99967",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 1.375,
			cy: 1.375,
			r: 1.375,
			transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 13.7078 9.37402)",
			stroke: "currentColor",
			strokeWidth: .916667,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.6665 7.99967L7.99984 7.99967",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export { SvgOneToOne as ReactComponent };
